/* Base translations · Fieldwork worksheets (disclosure checklist, ageing, GL, W9, W11, procedures, walkthroughs, ITGC, tests of controls, cut-off, head folders) — moved unchanged out of lib/i18n.js (STEP 6 · split 6f).
   Top-level keys owned by this file (no other base file and not i18n.js define them): dc, aging, gl, w9, w11, proc, wt, itgc, toc, cd, hfWs, assert. */
export const I18N_BASE_FIELDWORK = {
  en: {
    dc: {
      fw: { full: "Full IFRS", sme: "IFRS for SMEs", engagement: "Engagement framework", saved: "Reporting framework saved", prompt: "Set the reporting framework in engagement settings", changeLink: "Change framework in Engagement settings",
            mismatch: "Frameworks do not match: FS are presented under {pf} (Full IFRS) while this checklist is on {rf}." },
      title: "Disclosure Checklist", progressLbl: "Progress", edition: "Edition", filter: "Filter",
      chapter: "Chapter", allChapters: "All chapters", showing: "Showing {a} of {b}",
      loadMore: "Load more ({n} remaining)",
      locked: "Engagement is signed off — answers are read-only.",
      ans: { all: "All", unanswered: "Unanswered", yes: "Yes", no: "No", na: "N/A", ai: "AI suggested" },
      allTypes: "All types", answered: "answered", fsNotePh: "FS note / TB account", commentsPh: "Comments", openTb: "Open TB",
      so: { preparer: "Preparer", reviewer: "Reviewer", partner: "Partner", sign: "Sign" },
      ai: { settledNote: "{n} earlier suggestions on items since answered or scoped out are not counted.", running: "Pre-marking…", summaryLbl: "AI pre-mark", noSuggestion: "No suggestion", retryFailed: "Retry failed chunks",
            acceptAllShown: "Accept all shown", rowLabel: "AI suggestion — review required", accept: "Accept", reject: "Reject",
            acceptedN: "accepted", skippedN: "skipped (human answer kept)", acceptedTag: "from AI suggestion",
            failed: "AI pre-mark failed — please try again",
            applies: "Applies — verify", yesFs: "Yes (FS evidence)", noFs: "No (FS evidence)",
            appliesLabel: "AI: requirement applies — verify in FS", applicable: "Applicable — answer Yes / No" },
      loading: "Loading checklist…",
      scope: { title: "Scoping", chapterBtn: "Scope out chapter", sectionBtn: "Scope out section", itemBtn: "Scope out", applicable: "Mark applicable",
               scopedOut: "N/A — scoped out", reason: "Reason (required)", reasonPh: "Why this does not apply to the entity…", confirm: "Scope out", cancel: "Cancel",
               dlgTitle: "Scope out — {what}", dlgNote: "Every item in this scope is answered N/A (source: scoped out) and counts as complete. Any role on the engagement can mark it applicable again before the sign-off lock; earlier Yes / No answers come back.",
               level: "Level", what: "Chapter / section / item", items: "Items", by: "By", status: "Status", inForce: "In force", reverted: "Marked applicable",
               none: "Nothing scoped out.", saved: "Scoped out — {n} items set to N/A", revertedToast: "Marked applicable again — {r} answers restored, {c} back to unanswered",
               chapter: "Chapter", section: "Section", item: "Item", summaryCount: "{a} in force · {r} reverted", lockedNote: "Scoping is read-only after the sign-off.", viaScope: "scoped out with its {level}" },
      aiBatches: { progress: "Batch {k} of {n}", stopped: "Stopped — the AI allotment is used up. Completed batches are kept; the remaining batches run later with Retry.",
                   failed: "Failed / stopped batches", row: "Batch {i} ({n} items): {err}", retry: "Retry failed / stopped batches", estUnits: "Estimated units", batches: "Batches", batchSize: "of up to {n} items", scopedOut: "Scoped out (not sent)", answered: "Already answered (not sent)",
                   resume: "Resume ({n} batches)", resumeTitle: "Resume: {n} batches, {items} items", interrupted: "Interrupted at {k} / {n} — resume to finish the remaining batches.", finishing: "The previous part may still be finishing — try again in a few minutes.", resumeBusy: "A pre-mark run is in progress." },
      aiPreMark: "AI pre-mark",
      aiNote: "AI pre-mark — AI suggestion — review required",
      fs: {
        selectorLbl: "Financial statements used for AI pre-mark:", azex: "AZEX financial statements", uploaded: "Uploaded financial statements",
        upload: "Upload FS", uploading: "Uploading…", noFs: "No FS available — pre-mark can only suggest N/A or Applies — verify in FS",
        version: "Version", date: "Date", current: "current", latestUsed: "latest is used", view: "View", download: "Download",
        bin: "Move to bin", binned: "FS version moved to the Recycle Bin", uploadedOk: "FS uploaded", badType: "Only PDF or Word (.docx) files are accepted",
        used: "FS used", none: "none", changed: "FS changed since answer", openAt: "Open FS at page", viewerTitle: "Financial statements",
        pages: "pages", notFound: "not found in FS", azexHint: "Built live from Reporting → IFRS Statements",
      },
      pre: {
        title: "Run AI pre-mark", fsPages: "FS pages to read", items: "Items to check", noFsWarn: "No FS selected — only N/A / Applies — verify can be suggested.",
        cont: "Continue", cancel: "Cancel", unitsUsed: "units used", lastRun: "last run",
      },
      exp: {
        btn: "Export", title: "Export checklist", blank: "Blank checklist", filled: "Filled checklist",
        blankHint: "All items of the edition with empty Response / FS note / Comments.", filledHint: "Current accepted answers of this engagement.",
        format: "Format", edition: "Edition", chapters: "Chapters", allChapters: "All chapters", selected: "Selected", filter: "Filter",
        answered: "Answered", unanswered: "Unanswered", include: "Include columns", fsNote: "FS note / TB ref", comments: "Comments",
        by: "Answered by / at", signoffs: "Chapter sign-offs", aiCol: "AI suggestion (not accepted)", run: "Export", running: "Preparing…",
        done: "Export ready", failed: "Export failed",
      },
      col: {
        itemId: "Item ID", chapter: "Chapter", ref: "Ref", requirement: "Requirement",
        type: "Type", appliesWhen: "Applies when", response: "Response", fsNote: "FS note / TB ref", comments: "Comments",
      },
    },
    aging: {
      title: "Aging Analysis",
      subtitle: "Upload an AR or AP aging file to see the bucket breakdown",
      arTab: "Receivables (AR)",
      apTab: "Payables (AP)",
      uploadAr: "Upload AR aging",
      uploadAp: "Upload AP aging",
      downloadTemplate: "Download template",
      templateNote: "Use our recommended template: Party Name · Invoice Number · Invoice Date · Due Date · Amount · Currency · Notes.",
      bucket: "Bucket",
      amount: "Amount",
      share: "Share",
      party: "Party",
      noData: "No aging data uploaded yet. Download the template, fill it in, then upload it.",
      unknownLabel: "Due date missing",
      unknownHint: "Invoices missing a due date are not aged automatically. Investigate these before signing off — they are excluded from every standard bucket.",
      unknownCol: "Due date missing",
    },
    gl: {
      title: "GL Import",
      subtitle: "Upload General Ledger and map columns",
      chooseFile: "Choose file (.xlsx or .csv)",
      colMap: "Column mapping",
      preview: "Preview",
      commit: "Import to engagement",
      tbTitle: "Trial Balance",
      byCategory: "By category",
      balanced: "Balanced",
      unbalanced: "Not balanced",
      coa: "Chart of Accounts mapping",
      standardCategory: "Standard category",
      period: "Period",
      currentYear: "Current year",
      priorYear: "Prior year (for YoY comparison)",
      replaceExisting: "Delete existing entries before uploading",
      modeAdd: "Unchecked: the rows of this file are ADDED to what is already loaded for the selected year. The same file is refused a second time, and a file whose rows are already loaded is stopped.",
      modeReplace: "Checked: the rows of this file REPLACE everything already loaded for the selected year.",
      replaceConfirmTitle: "Replace existing GL data?",
      replaceConfirmDesc: "This will permanently delete all GL entries for the {period} period before importing {count} new rows. Continue?",
      confirmReplace: "Yes, replace",
      purge: "Delete all entries",
      purgeTitle: "Delete all GL entries for this period?",
      purgeConfirm: "Permanent: this cannot be undone. Re-upload the GL file to restore it. Every sample of the {period} period will need a re-run. Delete all GL entries for this period?",
      confirmDelete: "Yes, delete",
      unsupportedFormat: "Unsupported file type. Please upload .csv, .xlsx, .xls, or .xlsm.",
      rowLimitNote: "Row limit: 1,500,000 rows per upload. Larger files are rejected with a clear message.",
      loadedRows: "Loaded {n} rows",
      parsingFile: "Parsing file…",
      previewFailed: "Preview failed",
      uploadingChunks: "Uploading {mb} MB in chunks…",
      uploadFinalizeNoJob: "Upload finalize returned no job id",
      queuedMsg: "Queued…",
      queuedShort: "Queued",
      failed: "Failed",
      done: "Done",
      jobLine: "Job {id} · runs in background",
      ofRows: "of {n} rows",
      voucherWarnTitle: "No voucher / UIN column detected in this file",
      voucherWarnBody1Pre: "Every GL row imported without a voucher number will be given a system-generated placeholder (",
      voucherWarnBody1Post: ", ",
      voucherWarnBody1End: "…). These ",
      voucherWarnBody1BoldEnd: "cannot be reconciled to the client's physical vouchers",
      voucherWarnBody1Tail: " — vouching sheets will show the placeholder, not the real voucher/UIN.",
      voucherWarnBody2BoldPre: "Fix now:",
      voucherWarnBody2Post: " in the Column Mapping below, pick the column that holds the voucher / UIN / journal number (accepted headings include Voucher, Voucher No, UIN, JV No, Ref No, Bill No). Only proceed without one if the client genuinely posts GL without vouchers.",
      voucherAckBoldPre: "Proceed without a voucher / UIN column",
      voucherAckPost: " — I acknowledge every imported row will get a system-generated ",
      voucherAckTail: " placeholder, and vouching sheets won't be reconcilable to the client's physical vouchers until I re-import the GL with the voucher column mapped.",
      voucherLabelInMap: "Voucher / UIN",
      categoryAuto: "Category (auto-map)",
      postedByOpt: "Posted by (opt.)",
      postedTimeOpt: "Posted time (opt.)",
      approverOpt: "Approver (opt.)",   // Batch 31 · item 12 (M95)
      requiredMark: "← REQUIRED",
      previewCount: "{title} ({n} rows)",
      showingFirst: "showing first {n}",
      importedEntries: "Imported {n} entries",
      importedWithBalance: "Imported {n} entries. {b}",
      dupLinesLine: "{n} lines stored more than once (same account, date, amount, voucher, narration) in {g} groups — see A9001",
      dupLinesNone: "No line stored more than once",
      layerClientBooks: "Client books",
      replacedRows: "Replaced {del} rows; imported {ins}. {b}",
      importedTbRows: "Imported {n} TB rows",
      balancedTick: "Balanced ✔",
      unbalancedX: "Not balanced ✕",
      tbDrCr: "Dr: {dr} · Cr: {cr}",
      noGlDataYet: "No GL data yet. Upload a file above to see the trial balance.",
      tbColCode: "Code",
      tbColAccount: "Account",
      tbColCategory: "Category",
      tbColDebit: "Debit",
      tbColCredit: "Credit",
      tbColNet: "Net",
      tbDirectTitle: "Direct Trial Balance upload",
      tbDirectDescPre: "Skip the GL dump if the client only shares a Trial Balance. Expected columns (case-insensitive): ",
      tbDirectDescCols: "Account Code, Account Name, Debit, Credit, FS Mapping (optional), Note Reference (optional).",
      uploadTbDirectBtn: "Upload TB directly — .csv, .xlsx, .xls, .xlsm · max 45 MB",
      chooseFileFull: "{base} — .csv, .xlsx, .xls, .xlsm · max 45 MB",
      coaHintPre: "FS Mapping and Note Mapping for every account are edited on the dedicated Financial Statements Mapping page — the single source of truth for statement placement across CoA, TB and GL Import.",
      openFsMappingBtn: "Open FS Mapping",
      mappingUpdated: "Mapping updated",
      glCommitFailed: "GL commit failed",
      tbUploadFailed: "TB upload failed",
      purging: "Purging {n} rows…",
      purgeFailed: "Purge failed",
      deletedRows: "Deleted {n} rows ({period})",
      mapVoucherFirst: "Map the Voucher / UIN column, or tick the acknowledgement below to proceed without one.",
    },
    w9: {
      title: "Misstatement worksheet",
      subtitle: "Evaluation of uncorrected misstatements against 105(a).",
      tabUnresolved: "Unresolved",
      tabResolved: "Resolved",
      showVoided: "Show voided",
      voidedBadge: "voided",
      ct: "Clearly trivial threshold",
      pm: "Performance materiality",
      om: "Overall materiality",
      empty: "No misstatements yet. Send from any worksheet.",
      recomputing: "Recalculating…",
      computedBackend: "Recomputed",
      computedWorker: "Computed by worker",
      export: "Export schedule",
      exporting: "Exporting…",
      exportOk: "Schedule downloaded.",
      col: { fsHead: "FS head", description: "Description", type: "Type",
              amount: "Amount", sfp: "Effect on financial position",
              pl: "Effect on profit or loss", source: "Source",
              commDate: "Communicated to management",
              response: "Management response", ready: "In evaluation",
              count: "Count",
              net: "Net", gross: "Gross", compared: "Compared" },
      fpGross: "Gross effect on financial position",
      fpGrossHint: "Absolute amount, by FS head — for a gross-up or an overstatement of assets and liabilities with no net effect",
      correctWithEntry: "Correct with entry",
      correctedByEntry: "Corrected by {ref}",
      sourceLabels: {
        related_party: "Related party",
        completeness: "Completeness",
        estimate: "Estimate",
        observation: "Observation",
        discrepancy: "Discrepancy",
        w17_7: "W17.7 507(r)",
      },
      threshold: "Strategy-revision threshold",
      thresholdHint: "Default: performance materiality. Editable per engagement — changes logged.",
      strategyPromptQuiet: "Aggregate {aggregate} is below the strategy-revision threshold {threshold}.",
      signOff: "Sign off",
      signedOffBy: "Signed off by {name} · {date}",
      changeDate: "Change date",
      mtype: { Factual: "Factual", Judgmental: "Judgmental", Projected: "Projected", Disclosure: "Disclosure" },   // Disclosure: Batch 31 · item 10
      resp: { Corrected: "Corrected", Notcorrected: "Not corrected" },
      responsePh: "Pick…", reasonPh: "Reason required when not corrected",
      readyYes: "Yes", readyNo: "Missing inputs",
      readyReason: {
        missing_communicated_date: "Enter the date communicated to management",
        missing_response: "Pick a management response",
        missing_reason: "Reason is required when Not corrected",
        missing_effect: "Enter the effect on financial position, on profit or loss, or the gross effect on financial position",
        resolved: "",
      },
      pickSample: "Pick sample", basis: "Basis (manual)",
      projectedFromSample: "Projected from sample",
      evaluation: "Evaluation of misstatements",
      uncorrected: "Uncorrected misstatements — individually and in aggregate",
      totalAggregate: "Total (aggregate)",
      vsPm: "vs PM", vsOm: "vs OM",
      strategyPromptTitle: "Accumulated misstatements approach materiality — revisit the audit strategy",
      strategyPromptBody: "Compared aggregate {aggregate} has reached the strategy-revision threshold {threshold}.",
      strategyPromptQuiet: "Compared aggregate {aggregate} is below the strategy-revision threshold {threshold}.",
      strategyPromptNotePh: "Note the strategy revision, or explain why none is needed.",
      materialityReassessed: "Materiality still appropriate?",
      qualitative: "Qualitative factors",
      qual: { nature: "Nature", circumstances: "Circumstances",
                compliance_or_covenant: "Compliance / covenant",
                trend_reversal: "Trend reversal",
                management_remuneration: "Management remuneration",
                other: "Other" },
      priorPeriod: "Prior-period uncorrected misstatements",
      tcwg: "Communicated to those charged with governance",
      writtenRep: "Written representation obtained",
      wrPending: "Pending", wrObtained: "Obtained", wrNa: "Not applicable",
      openMRL: "Open Management Representation Letter",
      conclusion: "Conclusion",
      pickConclusion: "Pick a conclusion…",
      notMaterial: "Uncorrected misstatements are not material, individually or in aggregate",
      material: "Uncorrected misstatements are material",
      preparer: "Preparer", reviewer: "Reviewer",
      namePh: "Full name",
      notePh: "Note",
    },
    w11: {
      title: "Clearance gate",
      subtitle: "The 9 checks that must be green before the Partner may sign off.",
      subtitleReview: "Review clearance requirements — every check must be green before the Partner may sign off.",
      refresh: "Refresh",
      item: "Item", status: "Status", detail: "Detail",
      whoWhen: "Who / when", open: "Open",
      readyPartner: "All items are OK — Partner sign-off is allowed.",
      notReady: "{count} item(s) blocking Partner sign-off.",
      refusalNote: "The Partner sign-off is refused by the backend while any item above is Blocked. Fix the blockers and refresh.",
      pill: { ok: "OK", blocked: "Blocked", na: "N/A", warn: "Warning — sign-off missing" },
      warningsTitle: "Warnings (do not block the gate)",
      warnings: { dc_incomplete: "The Disclosure checklist is not fully answered — {answered} of {total} items answered, {open} still open. Finish it before the report is issued." },
      items: {
        checklist_1: "All worksheets and forms complete",
        checklist_2: "Review points cleared",
        checklist_3: "W9 concluded",
        checklist_4: "Written representations obtained",
        checklist_5: "Subsequent events reviewed",
        checklist_6: "Going concern (209(a)) concluded",
        checklist_7: "Engagement Quality Review completed",
        checklist_8: "W10 signed by preparer and reviewer",
        checklist_9: "Communication with those charged with governance",
        review_1: "All review worksheets (W17.1–W17.8) signed off",
        review_2: "W17.4 — all 9 required inquiries answered",
        review_3: "Review points cleared",
        review_4: "W9 concluded",
        review_5: "Written representations obtained",
        review_6: "Subsequent events reviewed",
        review_7: "Going concern (209(a)) concluded",
        review_8: "Engagement Quality Review completed",
        review_9: "W10 signed by preparer and reviewer",
        review_10: "Communication with those charged with governance",
        review_11: "Other review forms complete or N/A",
      },
      details: {
        forms_all_ok: "All included forms are 100% complete.",
        forms_incomplete: "{count} form(s) still incomplete:",
        other_forms_all_ok: "All other review forms are complete or marked N/A. Greyed audit-only forms are excluded.",
        other_forms_incomplete: "{count} review form(s) still incomplete or unmarked:",
        more_suffix: "(+{n} more)",
        rp_all_cleared: "All review points are Cleared.",
        rp_open: "{count} review point(s) not yet Cleared.",
        w9_not_material: "W9 conclusion: Not material.",
        w9_material: "W9 conclusion: Material.",
        w9_not_concluded: "W9 conclusion is not yet recorded.",
        w17_all_signed: "W17.1–W17.8 have all been signed off.",
        w17_pending: "W17 worksheets still pending sign-off: {missing}.",
        w17_4_all_answered: "All 9 required inquiries have been answered.",
        w17_4_pending: "{count} of the 9 required inquiries still unanswered.",
        wr_not_built: "Not built yet — Management representation letter is not in the current forms library.",
        wr_not_started: "Not started — Management representation letter has not been opened yet.",
        wr_incomplete: "Management representation letter is not yet complete.",
        wr_obtained: "Written representations obtained.",
        wr_na: "Marked Not applicable.",
        subs_not_built: "Not built yet — Subsequent events is not in the current forms library.",
        subs_not_started: "Not started — Subsequent events has not been opened yet.",
        subs_incomplete: "Subsequent events form is not yet complete.",
        subs_obtained: "Subsequent events reviewed.",
        subs_na: "Marked Not applicable.",
        gc_not_built: "Not built yet — 209(a) is not in the current forms library.",
        gc_not_started: "Not started — 209(a) has not been opened yet.",
        gc_pending: "Going concern (209(a)) conclusion not yet picked.",
        gc_concluded: "Going concern concluded — {option_label_key}.",
        gc_na: "Marked Not applicable.",
        eqr_not_required: "EQR is not required on this engagement.",
        eqr_ok: "Form 522(a) — Overall conclusion: Completed satisfactorily.",
        eqr_pending: "Form 522(a) is not yet 'Completed satisfactorily' (ISQM 2.24(b), 27; ISA 220 (Revised)).",
        w10_not_started: "W10 audit summary memo is not started.",
        w10_missing: "W10 missing sign-off: {roles}.",
        w10_signed: "W10 signed by preparer ({preparer_name}) and reviewer ({reviewer_name}).",
        tcwg_not_recorded: "TCWG communication date not yet recorded on W9.",
        tcwg_log_ok: "Latest communication {date} · {category} · {to}",
        tcwg_add_to_log: "Add a significant-findings row to the 311(a) log.",
        tcwg_ok: "TCWG communicated on {date}.",
        tcwg_na_ok: "TCWG communication marked N/A — reason: {reason}",
      },
      consistency: {
        recheck: "Re-check", na: "N/A", proceed: "Proceed to Partner sign-off", overrideTitle: "Failed consistency checks",
        overrideText: "These checks failed. Partner sign-off is not blocked, but your override will be written to the audit trail:",
        overrideConfirm: "Confirm override", overrideOk: "Override recorded in the audit trail — proceed to Partner sign-off",
        orphans: "orphans", entries: "entries", count: "count", lead: "lead", noLeads: "No lead sheets yet",
        title: "Consistency checks",
        warnOnly: "Warnings only — Partner sign-off is not blocked.",
        c1: "Same materiality used in planning, sampling and W9",
        c2: "Every risk links to a procedure (and every performed procedure to a risk)",
        c3: "W9 misstatements agree to 302(a) entries",
        c4: "Going-concern 209(a) matches the auditor-report emphasis / modification",
        c5: "Sign-off order: preparer ≤ reviewer ≤ partner",
        c6: "Lead-sheet totals agree to the trial balance per head",
        pass: "PASS", fail: "FAIL",
        detailFmt: {
          c1_ok: "Planning PM/TM match sampling and W9.",
          c1_bad: "{n} mismatch(es): {list}",
          c1_item: "{src} {field} = {used} vs expected {expected}",
          c1_specific: "not a sample — not compared",   // Batch 15 · N2 (F-116)
          c2_ok: "All risks have a linked procedure and every performed procedure links to a risk.",
          c2_orphans: "{n_risks} risk(s) without a linked procedure{maybe_procs}",
          c2_orphans_procs: " and {n_procs} performed procedure(s) with no linked risk",
          c2_risk_item: "Risk \u201C{title}\u201D has no linked procedure",
          c3_ok: "W9 and 302(a) agree on count ({n}).",
          c3_bad: "W9 count {w9} vs 302(a) count {f302}",
          c4_ok: "Going-concern decision matches the auditor report.",
          c4_bad: "209(a) says uncertainty = {gc}, auditor report has modification = {rpt}",
          c5_ok: "Sign-off order and dates are in sequence.",
          c5_bad: "Order violations: {list}",
          c6_ok: "All head folders reconcile to the TB.",
          c6_bad: "{n} head(s) off: {list}",
          c6_item: "{code}: TB {tb} vs Lead-sheet {lead} (Δ {diff})",
        },
      },
    },
    proc: {
      title: "Procedures performed",
      col: { ref: "Ref", proc: "Procedure", assertions: "Assertions",
              source: "Source", performed: "Performed", reason: "Reason / comment",
              doneBy: "Done by / date", wp: "WP ref" },
      yes: "Yes", no: "No", na: "N/A",
      naReason: "N/A requires a reason", noReason: "'No' requires a comment",
      source: { library: "Library", plan: "Response Plan",
                 additional: "Additional", alternate: "Alternate" },
      replaced: "Replaced by alternate",
      addAdditional: "Add additional procedure", addAlternate: "Add alternate",
      completePct: "Completed",
      conclusion: "Conclusion", preparer: "Preparer", reviewer: "Reviewer",
      markComplete: "Mark complete",
      newProcedure: "Procedure text",
      pickAlternateOriginal: "Original procedure to replace",
      guard: {
        notDecided: "Set the scoping decision in Planning → Scoping to load the library procedures.",
        notDecidedLink: "Open Scoping",
      },
    },
    wt: {
      title: "Walkthroughs + Design & Implementation",
      purpose: "One row per process. \"Rely on control = Yes\" creates a Tests of Controls row.",
      required: "Description or Control ID is required.",
      saved: "Walkthrough saved",
      noSeed203a: "Nothing to carry over from 203(a)",
      empty: "No walkthroughs yet — add one above.",
      add: "Add walkthrough",
      saveBtn: "Save walkthrough",
      relyOnControl: "Rely on control (→ Tests of Controls)",
      effective: "Effective",
      ineffective: "Ineffective",
      na: "N/A",
      processPh: "e.g. Revenue cut-off",
      procedurePh: "Walkthrough procedure",
      controlIdPh: "Control ID",
      assertionPh: "Assertion (e.g. E, C, A)",
      riskRefPh: "Pick a risk from the register…",
      descriptionPh: "Control description",
      objectivePh: "Objective",
      ownerPh: "Owner",
      walkthroughDone: "Walkthrough done",
      designEffective: "Design effective",
      implemented: "Implemented",
      deficiencyFlag: "Deficiency (→ log)",
      attachEvidence: "Attach evidence",
      evidenceAttached: "Evidence attached.",
      sourceForm203a: "Source form: 203(a) →",
      col: {
        ref: "Ref", area: "Area", procedure: "Procedure",
        conclusion: "D&I", rely: "Rely",
        controlId: "Control ID", description: "Description", objective: "Objective",   // B35-7: the walkthrough table Objective column
        assertion: "Assertion", ma: "M/A", pd: "P/D", freq: "Frequency",
        owner: "Owner", di: "D&I", impl: "Impl.",
        deficiency: "Def?", evidence: "Evidence",
      },
      ma: { manual: "Manual", automated: "Automated", it_dependent: "IT-dependent" },
      pd: { preventive: "Preventive", detective: "Detective" },
      freq: {
        daily: "Daily", weekly: "Weekly", monthly: "Monthly",
        quarterly: "Quarterly", annually: "Annually", on_occurrence: "On occurrence",
      },
      controlCycle: "Control cycle",
      controlCycleHint: "Flowchart, narrative or process document. Files are kept with the engagement.",
      walkthroughDateLabel: "Walkthrough date",
      sourceForm203a: "Source form: 203(a) →",
      attachFile: "Attach file",
      noFiles: "No files yet.",
      cycleAttached: "Control-cycle file attached.",
      process: {
        revenue: "Revenue",
        purchases: "Purchases",
        payroll: "Payroll",
        cash: "Cash",
        inventory: "Inventory",
        financial_close: "Financial close",
      },
    },
    itgc: {
      title: "IT General Controls",
      purpose: "Four domains: access security · change management · IT operations · program development.",
      pass: "Pass", fail: "Fail", na: "N/A", not_assessed: "Not assessed",
      notePh: "Note / evidence ref",
      domain: {
        access_security: "Access security",
        change_management: "Change management",
        it_operations: "IT operations",
        program_development: "Program development",
      },
      col: {
        domain: "Domain", control: "Control", status: "Status", note: "Note",
        controlId: "Control ID", controlIdPh: "Control ID", description: "Description",
        ma: "Manual / Automated", pd: "Preventive / Detective",
        freq: "Frequency", owner: "Owner",
        di: "Design effective", impl: "Implemented", rely: "Rely on control",
      },
    },
    toc: {
      title: "Tests of Controls",
      purpose: "Operating-effectiveness tests of controls we intend to rely on.",
      refRequired: "Control ref is required.",
      saved: "Test row saved",
      empty: "No tests of controls yet.",
      add: "Add test of controls",
      saveBtn: "Save test",
      controlRefPh: "e.g. WT-01",
      attributePh: "Attribute being tested",
      relied: "Relied",
      notRelied: "Not relied",
      naTitle: "N/A — no controls reliance",
      naExplain: "No walkthrough is set to rely on the control, so no tests of operating effectiveness are performed.",
      naReason: "Reason (documented)",
      naReasonPh: "e.g. Fully substantive approach adopted.",
      col: { ref: "Ref", control: "Control", attribute: "Attribute",
              sample: "Sample", exceptions: "Exceptions", conclusion: "Conclusion" },
    },
    cd: {
      title: "Control Deficiency Log",
      purpose: "ISA 265 — Deficiency and Significant deficiency. Significant rows feed 322(a) Management Letter.",
      descRequired: "Description is required.",
      tcwgRequired: "TCWG communication date is required for a Significant deficiency.",
      tcwgHint: "TCWG communication date is required before this row can move out of Open.",
      saved: "Deficiency logged",
      empty: "No deficiencies logged yet.",
      add: "Log a new deficiency",
      saveBtn: "Log deficiency",
      descPh: "Describe the deficiency…",
      controlIdPh: "Control ID (optional)",
      areaPh: "Control area",
      wpPh: "e.g. 4101-05.02",
      wpLabel: "WP link",
      commMgmtPh: "Management letter date",
      commTcwgPh: "TCWG date",
      commMgmtLabel: "Communicated to management",
      commTcwgLabel: "Communicated to TCWG (required for Significant)",
      deficiency: "Deficiency",
      significant: "Significant deficiency",
      feeds322a: "{count} entries feed 322(a) Management Letter.",
      source: { manual: "Manual", walkthroughs: "Walkthrough",
                 tests_of_controls: "Tests of controls",
                 itgc: "ITGC", observation: "Head observation" },
      status: { open: "Open", communicated: "Communicated", cleared: "Closed" },
      col: { ref: "Ref", source: "Source", controlId: "Control ID",
              desc: "Description", severity: "Severity",
              commMgmt: "Comm. Mgmt", commTcwg: "Comm. TCWG",
              status: "Status" },
    },

    assert: {
      E: "Existence / occurrence", C: "Completeness", A: "Accuracy",
      V: "Valuation and allocation", CO: "Cut-off", R: "Rights and obligations",
      CL: "Classification", P: "Presentation and disclosure", All: "All",
    },
    hfWs: {
      aging: {
        title: "Aging worksheet",
        arTitle: "AR Aging — 1203-06",
        apTitle: "AP Aging — 3203-06",
        arTitleShort: "AR aging",
        apTitleShort: "AP aging",
        tbTrade: "TB balance (trade) = sum of ticked accounts.",
        agingTotal: "Aging total (from aging report)",
        tbBalance: "TB balance (trade receivables / payables only)",
        folderTotal: "Folder total (all accounts in folder)",
        difference: "Difference (ledger − aging)",
        linkedUpload: "Aging upload used",
        differenceZero: "Aging reconciles to TB. ✓",
        differenceNonZero: "Aging does NOT reconcile to TB — explain and conclude.",
        explanation: "Explanation of the difference",
        explanationReq: "Required when difference ≠ 0.",
        conclusion: "Conclusion",
        preparer: "Preparer",
        completedAt: "Completed at",
        markComplete: "Mark complete",
        markCompleteGate: "Fill explanation (if diff ≠ 0) + conclusion first.",
        completedBadge: "Completed",
        loading: "Loading worksheet…",
        noAgingUpload: "No aging report uploaded for this folder yet.",
        coaFieldNote: "TB filter uses coa_mappings.mapping ⊇ 'trade' AND 'receivab'/'payab' with fs_mapping = {code}.",
        accountsTitle: "Accounts in this folder",
        colTrade: "Trade",
        colCode: "Code",
        colName: "Account name",
        colBalance: "TB balance",
        colTag: "Status",
        blankName: "blank name",
        needsClassification: "Needs classification",
        suggestedTrade: "Suggested: trade",
        suggestedNonTrade: "Suggested: non-trade",
        overridden: "Auditor override",
        markCompleteGateUnclassified: "Classify every account (tick or untick Trade) first.",
      },
      badge: {
        cutoff: "Cut-off",
        aging: "Aging",
        completeness: "Completeness",
        inventory_count: "Inventory count",
        estimate: "Estimate",
        related_party: "Related party",
      },
      row: {
        completeness: "Completeness worksheet",
        inventory_count: "Inventory count worksheet",
        estimate: "Estimate worksheet",
        related_party: "Related-party transactions",
        aging: "Aging",
        cutoff: "Cut-off",
      },
      addWorksheet: "Add worksheet",
      added: "Worksheet added",
      cutoff: {
        title: "Cut-off worksheet",
        titleShort: "Cut-off test",
        rowText: "Cut-off test",
        std: "ISA 330; ISA 500",
        stdCodes: ["ISA 330", "ISA 500"],
        stdSep: "; ",
        windowDays: "Days before / after period end",
        colDate: "Date",
        colVoucher: "Voucher",
        colAccount: "Account",
        colAmount: "Amount",
        recordedCorrectly: "Recorded in the correct period?",
        remarks: "Remarks",
        support: "Support",
        supportDocLabel: "Supporting document",
        replace: "Replace",
        view: "View",
        yes: "Yes",
        no: "No",
        preYearEnd: "Pre-year-end entries (auto-picked)",
        postYearEnd: "Post-year-end entries",
        uploadPye: "Upload post-year-end GL (.xlsx / .csv)",
        uploadPyeCols: "Columns: Date, Voucher, Account, Amount, Description",
        uploadDocs: "Upload documents",
        uploadDocsHint: "Delivery notes, invoices, credit notes dated after period end. Multiple files allowed.",
        conclusion: "Conclusion",
        preparer: "Preparer",
        conclusionDate: "Date",
        completedAt: "Completed at",
        markComplete: "Mark complete",
        markCompleteGate: "Fill conclusion, preparer and date first.",
        sendBtn: "Send to misstatements",
        sentIndicator: "Sent to misstatements", resendBtn: "Send again (refresh amount)",
        noAccounts: "This folder has no accounts on the current FS mapping — worksheet not created.",
        uploadedBy: "By",
        uploadedAt: "On",
      },
    },
  },
  ar: {
    wt: {
      title: "اختبار التتبع + التصميم والتطبيق",
      purpose: "صف واحد لكل عملية. عند اختيار «الاعتماد على الضابط = نعم» يُنشأ صف في اختبارات الضوابط.",
      required: "الوصف أو معرف الضابط مطلوب.",
      saved: "تم حفظ اختبار التتبع",
      empty: "لا توجد اختبارات تتبع بعد — أضِف صفًا بالأعلى.",
      add: "إضافة اختبار تتبع",
      saveBtn: "حفظ اختبار التتبع",
      relyOnControl: "الاعتماد على الضابط (← اختبارات الضوابط)",
      effective: "فعّال",
      ineffective: "غير فعّال",
      na: "غير منطبق",
      processPh: "مثال: فصل الإيرادات بين الفترات",
      procedurePh: "إجراء اختبار التتبع",
      controlIdPh: "معرف الضابط",
      assertionPh: "التوكيد (مثل E, C, A)",
      riskRefPh: "اختر مخاطرة من السجل…",
      descriptionPh: "وصف الضابط",
      objectivePh: "الهدف",
      ownerPh: "المسؤول",
      walkthroughDone: "تم اختبار التتبع",
      designEffective: "التصميم فعّال",
      implemented: "مُطبَّق",
      deficiencyFlag: "قصور في الرقابة (← السجل)",
      attachEvidence: "إرفاق الدليل",
      evidenceAttached: "تم إرفاق الدليل.",
      sourceForm203a: "نموذج المصدر: 203(a) ←",
      col: {
        ref: "المرجع", area: "المجال", procedure: "الإجراء",
        conclusion: "التصميم والتطبيق", rely: "الاعتماد",
        controlId: "معرف الضابط", description: "الوصف", objective: "الهدف",
        assertion: "التوكيد", ma: "يدوي/آلي", pd: "وقائي/كاشف",
        freq: "التكرار", owner: "المسؤول", di: "التصميم والتطبيق", impl: "التطبيق",
        deficiency: "قصور؟", evidence: "الدليل",
      },
      ma: { manual: "يدوي", automated: "آلي", it_dependent: "معتمد على تقنية المعلومات" },
      pd: { preventive: "وقائي", detective: "كاشف" },
      freq: {
        daily: "يومي", weekly: "أسبوعي", monthly: "شهري",
        quarterly: "ربع سنوي", annually: "سنوي", on_occurrence: "عند الحدوث",
      },
      controlCycle: "دورة الرقابة",
      controlCycleHint: "مخطط تدفق أو سرد أو مستند العملية. تُحفظ الملفات في تخزين المنصة.",
      walkthroughDateLabel: "تاريخ اختبار التتبع",
      attachFile: "إرفاق ملف",
      noFiles: "لا توجد ملفات بعد.",
      cycleAttached: "تم إرفاق ملف دورة الرقابة.",
      process: {
        revenue: "الإيرادات",
        purchases: "المشتريات",
        payroll: "الرواتب",
        cash: "النقد",
        inventory: "المخزون",
        financial_close: "الإقفال المالي",
      },
    },
    cd: {
      title: "سجل قصور الرقابة",
      purpose: "ISA 265 — قصور في الرقابة وقصور جوهري. الصفوف الجوهرية تُغذّي 322(a) خطاب الإدارة.",
      descRequired: "الوصف مطلوب.",
      tcwgRequired: "تاريخ إبلاغ المكلفين بالحوكمة (TCWG) مطلوب لكل قصور جوهري.",
      tcwgHint: "تاريخ إبلاغ المكلفين بالحوكمة مطلوب قبل نقل الصف من «مفتوح».",
      saved: "تم تسجيل القصور",
      empty: "لم يُسجَّل أي قصور بعد.",
      add: "تسجيل قصور جديد",
      saveBtn: "تسجيل القصور",
      descPh: "صف القصور…",
      controlIdPh: "معرف الضابط (اختياري)",
      areaPh: "مجال الرقابة",
      wpPh: "مثال: \u20664101-05.02\u2069",
      wpLabel: "رابط ورقة العمل",
      commMgmtPh: "تاريخ خطاب الإدارة",
      commTcwgPh: "تاريخ الإبلاغ للمكلفين بالحوكمة",
      commMgmtLabel: "تاريخ إبلاغ الإدارة",
      commTcwgLabel: "تاريخ إبلاغ المكلفين بالحوكمة (TCWG) (مطلوب للقصور الجوهري)",
      deficiency: "قصور في الرقابة",
      significant: "قصور جوهري",
      feeds322a: "عدد الإدخالات التي تغذّي 322(a) خطاب الإدارة: {count}",
      source: {
        manual: "يدوي", walkthroughs: "اختبار التتبع",
        tests_of_controls: "اختبارات الضوابط", itgc: "الضوابط العامة لتقنية المعلومات (ITGC)",
        observation: "ملاحظة — مجلدات البنود",
      },
      status: { open: "مفتوح", communicated: "أُبلغ", cleared: "مُغلق" },
      col: {
        ref: "المرجع", source: "المصدر", controlId: "معرف الضابط",
        desc: "الوصف", severity: "الشدة",
        commMgmt: "إبلاغ الإدارة", commTcwg: "إبلاغ المكلفين بالحوكمة",
        status: "الحالة",
      },
    },
    itgc: {
      title: "الضوابط العامة لتقنية المعلومات (ITGC)",
      purpose: "أربعة مجالات: أمن الوصول · إدارة التغيير · عمليات تقنية المعلومات · تطوير البرامج.",
      pass: "ناجح", fail: "غير ناجح", na: "غير منطبق", not_assessed: "لم يُقيَّم",
      notePh: "ملاحظة / مرجع الدليل",
      domain: {
        access_security: "أمن الوصول",
        change_management: "إدارة التغيير",
        it_operations: "عمليات تقنية المعلومات",
        program_development: "تطوير البرامج",
      },
      col: {
        domain: "المجال", control: "الضابط", status: "الحالة", note: "ملاحظة",
        controlId: "معرف الضابط", description: "الوصف",
        ma: "يدوي / آلي", pd: "وقائي / كاشف",
        freq: "التكرار", owner: "المسؤول",
        di: "التصميم فعّال", impl: "مُطبَّق", rely: "الاعتماد على الضابط",
      },
    },
    toc: {
      title: "اختبارات الضوابط",
      purpose: "اختبارات فعالية التشغيل للضوابط التي ننوي الاعتماد عليها.",
      refRequired: "مرجع الضابط مطلوب.",
      saved: "تم حفظ صف الاختبار",
      empty: "لا توجد اختبارات ضوابط بعد.",
      add: "إضافة اختبار ضابط",
      saveBtn: "حفظ الاختبار",
      controlRefPh: "مثال: WT-01",
      attributePh: "السمة المُختبَرة",
      relied: "معتمَد",
      notRelied: "غير معتمَد",
      naTitle: "غير منطبق — لا يوجد اعتماد على الضوابط",
      naExplain: "لا يوجد اختبار تتبع يعتمد على الضابط، فلا تُنفَّذ اختبارات فعالية التشغيل.",
      naReason: "السبب (موثَّق)",
      naReasonPh: "مثال: تم اعتماد منهج جوهري بالكامل.",
      col: {
        ref: "المرجع", control: "الضابط", attribute: "السمة",
        sample: "العينة", exceptions: "الاستثناءات", conclusion: "الاستنتاج",
      },
    },
    gl: {
      title: "استيراد الأستاذ العام",
      subtitle: "قم برفع دفتر الأستاذ العام وربط الأعمدة",
      chooseFile: "اختر ملفاً (.xlsx أو .csv)",
      colMap: "ربط الأعمدة",
      preview: "معاينة",
      commit: "استيراد إلى المهمة",
      tbTitle: "ميزان المراجعة",
      byCategory: "حسب الفئة",
      balanced: "متوازن",
      unbalanced: "غير متوازن",
      coa: "ربط دليل الحسابات",
      standardCategory: "الفئة القياسية",
      period: "الفترة",
      currentYear: "السنة الحالية",
      priorYear: "السنة السابقة (للمقارنة)",
      replaceExisting: "استبدال البيانات الحالية قبل الرفع",
      modeAdd: "غير محدد: تُضاف صفوف هذا الملف إلى ما هو محمّل أصلاً للسنة المختارة. يُرفض الملف نفسه مرة ثانية، ويُوقف ملف صفوفه محمّلة أصلاً.",
      modeReplace: "محدد: تحل صفوف هذا الملف محل كل ما هو محمّل أصلاً للسنة المختارة.",
      replaceConfirmTitle: "استبدال بيانات الأستاذ الحالية؟",
      replaceConfirmDesc: "سيتم حذف جميع قيود الأستاذ للفترة {period} بشكل دائم قبل رفع {count} صف. هل تريد المتابعة؟",
      confirmReplace: "نعم، استبدل البيانات",
      purge: "حذف جميع القيود",
      purgeTitle: "حذف جميع قيود الأستاذ لهذه الفترة؟",
      purgeConfirm: "حذف نهائي: لا يمكن التراجع عنه. أعد رفع ملف الأستاذ لاستعادته. كل عينة من فترة {period} ستحتاج إلى إعادة تشغيل. حذف جميع قيود الأستاذ لهذه الفترة؟",
      confirmDelete: "نعم، احذف",
      unsupportedFormat: "صيغة غير مدعومة. يرجى رفع .csv أو .xlsx أو .xls أو .xlsm",
      rowLimitNote: "الحد الأقصى: 1,500,000 صف لكل رفع. الملفات الأكبر سيتم رفضها.",
      loadedRows: "تم تحميل {n} صفًا",
      parsingFile: "جاري تحليل الملف…",
      previewFailed: "فشلت المعاينة",
      uploadingChunks: "جاري تحميل {mb} ميغابايت في أجزاء…",
      uploadFinalizeNoJob: "لم يُرجع إنهاء التحميل معرف مهمة",
      queuedMsg: "في قائمة الانتظار…",
      queuedShort: "في قائمة الانتظار",
      failed: "فشل",
      done: "تم",
      jobLine: "المهمة {id} · تعمل في الخلفية",
      ofRows: "من {n} صف",
      voucherWarnTitle: "لم يتم اكتشاف عمود سند / UIN في هذا الملف",
      voucherWarnBody1Pre: "كل صف من الأستاذ العام يُستورد بدون رقم سند سيحصل على عنصر نائب مُنشأ آليًا (",
      voucherWarnBody1Post: "، ",
      voucherWarnBody1End: "…). لا يمكن ",
      voucherWarnBody1BoldEnd: "مطابقة هذه الصفوف بالسندات الفعلية للعميل",
      voucherWarnBody1Tail: " — ستُظهر أوراق التحقق العنصر النائب بدلاً من رقم السند/UIN الحقيقي.",
      voucherWarnBody2BoldPre: "الحل الآن:",
      voucherWarnBody2Post: " في تخطيط الأعمدة أدناه، اختر العمود الذي يحمل رقم السند / UIN / رقم القيد (العناوين المقبولة تشمل Voucher وVoucher No وUIN وJV No وRef No وBill No). لا تتابع بدون سند إلا إذا كان العميل حقًا لا يستخدم سندات.",
      voucherAckBoldPre: "المتابعة بدون عمود سند / UIN",
      voucherAckPost: " — أُقرّ بأن كل صف مستورد سيحصل على عنصر نائب مُنشأ آليًا ",
      voucherAckTail: "، ولن تكون أوراق التحقق قابلة للمطابقة مع سندات العميل الفعلية حتى أعيد استيراد الأستاذ العام مع ربط عمود السند.",
      voucherLabelInMap: "السند / UIN",
      categoryAuto: "الفئة (ربط تلقائي)",
      postedByOpt: "قيّد بواسطة (اختياري)",
      postedTimeOpt: "وقت القيد (اختياري)",
      approverOpt: "المعتمد (اختياري)",   // Batch 31 · item 12 (M95)
      requiredMark: "← مطلوب",
      previewCount: "{title} ({n} صف)",
      showingFirst: "عرض أول {n}",
      importedEntries: "تم استيراد {n} قيد",
      importedWithBalance: "تم استيراد {n} قيد. {b}",
      dupLinesLine: "{n} سطرًا مخزّنًا أكثر من مرة (نفس الحساب والتاريخ والمبلغ والمستند والبيان) في {g} مجموعات — انظر A9001",
      dupLinesNone: "لا يوجد سطر مخزّن أكثر من مرة",
      layerClientBooks: "دفاتر العميل",
      replacedRows: "استُبدل {del} صف؛ استُورد {ins}. {b}",
      importedTbRows: "تم استيراد {n} صف من ميزان المراجعة",
      balancedTick: "متوازن ✔",
      unbalancedX: "غير متوازن ✕",
      tbDrCr: "مدين: {dr} · دائن: {cr}",
      noGlDataYet: "لا توجد بيانات أستاذ عام بعد. قم برفع ملف أعلاه لرؤية ميزان المراجعة.",
      tbColCode: "الكود",
      tbColAccount: "الحساب",
      tbColCategory: "الفئة",
      tbColDebit: "مدين",
      tbColCredit: "دائن",
      tbColNet: "الصافي",
      tbDirectTitle: "رفع ميزان المراجعة مباشرة",
      tbDirectDescPre: "تخطى تفريغ الأستاذ العام إذا كان العميل يشارك فقط ميزان مراجعة. الأعمدة المتوقعة (غير حساسة لحالة الأحرف): ",
      tbDirectDescCols: "كود الحساب، اسم الحساب، مدين، دائن، تخطيط القوائم المالية (اختياري)، مرجع الإيضاح (اختياري).",
      uploadTbDirectBtn: "رفع ميزان المراجعة مباشرة — .csv, .xlsx, .xls, .xlsm · الحد الأقصى 45 ميغابايت",
      chooseFileFull: "{base} — .csv, .xlsx, .xls, .xlsm · الحد الأقصى 45 ميغابايت",
      coaHintPre: "يتم تعديل تخطيط القوائم المالية وتخطيط الإيضاحات لكل حساب في صفحة تخطيط القوائم المالية المخصصة — المصدر الوحيد للحقيقة لوضع البند في القوائم عبر دليل الحسابات وميزان المراجعة واستيراد الأستاذ العام.",
      openFsMappingBtn: "افتح تخطيط القوائم المالية",
      mappingUpdated: "تم تحديث التخطيط",
      glCommitFailed: "فشل تسجيل الأستاذ العام",
      tbUploadFailed: "فشل رفع ميزان المراجعة",
      purging: "جاري حذف {n} صف…",
      purgeFailed: "فشل الحذف",
      deletedRows: "تم حذف {n} صف ({period})",
      mapVoucherFirst: "قم بربط عمود السند / UIN، أو ضع علامة على الإقرار أدناه للمتابعة بدونه.",
    },
    aging: {
      title: "تحليل الأعمار",
      subtitle: "قم برفع ملف أعمار الذمم المدينة أو الدائنة لعرض تفصيل الفئات العمرية",
      arTab: "الذمم المدينة (AR)",
      apTab: "الذمم الدائنة (AP)",
      uploadAr: "رفع أعمار المدينين",
      uploadAp: "رفع أعمار الدائنين",
      downloadTemplate: "تنزيل النموذج",
      templateNote: "استخدم النموذج الموصى به: اسم الطرف · رقم الفاتورة · تاريخ الفاتورة · تاريخ الاستحقاق · المبلغ · العملة · ملاحظات.",
      bucket: "الفئة العمرية",
      amount: "المبلغ",
      share: "النسبة",
      party: "الطرف",
      noData: "لم يتم رفع بيانات أعمار بعد. نزّل النموذج، املأه، ثم ارفعه.",
      unknownLabel: "تاريخ الاستحقاق مفقود",
      unknownHint: "الفواتير التي لا تحتوي على تاريخ استحقاق لا يتم تصنيفها عمرياً تلقائياً. راجعها قبل التوقيع النهائي — فهي مستثناة من كل فئة قياسية.",
      unknownCol: "تاريخ الاستحقاق مفقود",
    },
    dc: {
      fw: { full: "المعايير الدولية الكاملة", sme: "المعيار الدولي للمنشآت الصغيرة والمتوسطة", engagement: "إطار المهمة", saved: "تم حفظ إطار التقرير", prompt: "حدّد إطار التقرير المالي في إعدادات المهمة", changeLink: "تغيير الإطار في إعدادات المهمة",
            mismatch: "الإطاران غير متطابقين: القوائم المالية معروضة وفق {pf} (المعايير الدولية الكاملة) بينما هذه القائمة على {rf}." },
      title: "قائمة الإفصاحات", progressLbl: "التقدم", edition: "الإصدار", filter: "تصفية",
      chapter: "الفصل", allChapters: "كل الفصول", showing: "عرض {a} من {b}",
      loadMore: "تحميل المزيد (متبقٍ {n})",
      locked: "تم توقيع المهمة — الإجابات للقراءة فقط.",
      ans: { all: "الكل", unanswered: "بدون إجابة", yes: "نعم", no: "لا", na: "لا ينطبق", ai: "مقترح الذكاء الاصطناعي" },
      allTypes: "كل الأنواع", answered: "مُجاب", fsNotePh: "إيضاح القوائم / حساب ميزان المراجعة", commentsPh: "ملاحظات", openTb: "فتح ميزان المراجعة",
      so: { preparer: "المُعد", reviewer: "المراجع", partner: "الشريك", sign: "توقيع" },
      ai: { settledNote: "{n} اقتراحًا سابقًا على بنود أُجيب عنها أو استُبعدت لاحقًا لا تُحتسب.", running: "جاري التعليم المسبق…", summaryLbl: "التعليم المسبق بالذكاء الاصطناعي", noSuggestion: "لا يوجد اقتراح", retryFailed: "إعادة محاولة الأجزاء الفاشلة",
            acceptAllShown: "قبول كل المعروض", rowLabel: "اقتراح ذكاء اصطناعي — يتطلب مراجعة", accept: "قبول", reject: "رفض",
            acceptedN: "تم قبولها", skippedN: "تم تخطيها (الإجابة البشرية محفوظة)", acceptedTag: "من اقتراح الذكاء الاصطناعي",
            failed: "فشل التعليم المسبق — يرجى المحاولة مرة أخرى",
            applies: "ينطبق — تحقق", yesFs: "نعم (دليل من القوائم)", noFs: "لا (دليل من القوائم)",
            appliesLabel: "الذكاء الاصطناعي: المتطلب ينطبق — تحقق في القوائم المالية", applicable: "ينطبق — أجب نعم / لا" },
      loading: "جاري تحميل القائمة…",
      scope: { title: "تحديد النطاق", chapterBtn: "إخراج الفصل من النطاق", sectionBtn: "إخراج القسم من النطاق", itemBtn: "إخراج من النطاق", applicable: "اعتبار منطبقًا",
               scopedOut: "لا ينطبق — خارج النطاق", reason: "السبب (إلزامي)", reasonPh: "لماذا لا ينطبق هذا على المنشأة…", confirm: "إخراج من النطاق", cancel: "إلغاء",
               dlgTitle: "إخراج من النطاق — {what}", dlgNote: "كل بند في هذا النطاق يُجاب عليه بـ «لا ينطبق» (المصدر: خارج النطاق) ويُحتسب مكتملًا. يمكن لأي دور في المهمة إعادته إلى النطاق قبل قفل التوقيع؛ وتعود إجابات نعم / لا السابقة.",
               level: "المستوى", what: "الفصل / القسم / البند", items: "البنود", by: "بواسطة", status: "الحالة", inForce: "ساري", reverted: "أُعيد إلى النطاق",
               none: "لا يوجد شيء خارج النطاق.", saved: "أُخرج من النطاق — {n} بندًا أصبحت «لا ينطبق»", revertedToast: "أُعيد إلى النطاق — استُعيدت {r} إجابة، و{c} عادت بدون إجابة",
               chapter: "فصل", section: "قسم", item: "بند", summaryCount: "{a} ساري · {r} مُلغى", lockedNote: "تحديد النطاق للقراءة فقط بعد التوقيع.", viaScope: "خارج النطاق مع {level}" },
      aiBatches: { progress: "الدفعة {k} من {n}", stopped: "توقف — نفدت حصة الذكاء الاصطناعي. الدفعات المكتملة محفوظة؛ وتُشغَّل الدفعات المتبقية لاحقًا بزر إعادة المحاولة.",
                   failed: "دفعات فاشلة / متوقفة", row: "الدفعة {i} ({n} بندًا): {err}", retry: "إعادة محاولة الدفعات الفاشلة / المتوقفة", estUnits: "الوحدات المقدَّرة", batches: "الدفعات", batchSize: "بحد أقصى {n} بندًا", scopedOut: "خارج النطاق (لا يُرسل)", answered: "مُجاب مسبقًا (لا يُرسل)",
                   resume: "استئناف ({n} دفعات)", resumeTitle: "استئناف: {n} دفعات، {items} بندًا", interrupted: "توقف التشغيل عند {k} / {n} — استأنف لإكمال الدفعات المتبقية.", finishing: "قد يكون الجزء السابق لا يزال قيد الإنهاء — حاول مرة أخرى بعد بضع دقائق.", resumeBusy: "تشغيل الإشارة المسبقة قيد التنفيذ." },
      aiPreMark: "تعليم مسبق بالذكاء الاصطناعي",
      aiNote: "تعليم مسبق بالذكاء الاصطناعي — اقتراح يتطلب مراجعة",
      fs: {
        selectorLbl: "القوائم المالية المستخدمة للتعليم المسبق بالذكاء الاصطناعي:", azex: "القوائم المالية من النظام", uploaded: "قوائم مالية مرفوعة",
        upload: "رفع القوائم المالية", uploading: "جاري الرفع…", noFs: "لا تتوفر قوائم مالية — يمكن للتعليم المسبق اقتراح لا ينطبق أو ينطبق — تحقق فقط",
        version: "الإصدار", date: "التاريخ", current: "الحالي", latestUsed: "يُستخدم الأحدث", view: "عرض", download: "تنزيل",
        bin: "نقل إلى السلة", binned: "تم نقل إصدار القوائم إلى سلة المحذوفات", uploadedOk: "تم رفع القوائم المالية", badType: "يُقبل فقط ملفات PDF أو Word (.docx)",
        used: "القوائم المستخدمة", none: "لا شيء", changed: "تغيّرت القوائم بعد الإجابة", openAt: "فتح القوائم عند الصفحة", viewerTitle: "القوائم المالية",
        pages: "صفحات", notFound: "غير موجود في القوائم", azexHint: "تُبنى مباشرة من التقارير ← قوائم IFRS",
      },
      pre: {
        title: "تشغيل التعليم المسبق", fsPages: "صفحات القوائم للقراءة", items: "البنود للفحص", noFsWarn: "لم تُحدَّد قوائم مالية — يمكن اقتراح لا ينطبق / ينطبق — تحقق فقط.",
        cont: "متابعة", cancel: "إلغاء", unitsUsed: "وحدات مستخدمة", lastRun: "آخر تشغيل",
      },
      exp: {
        btn: "تصدير", title: "تصدير القائمة", blank: "قائمة فارغة", filled: "قائمة معبأة",
        blankHint: "كل بنود الإصدار مع أعمدة الاستجابة / الإيضاح / الملاحظات فارغة.", filledHint: "الإجابات المقبولة الحالية لهذه المهمة.",
        format: "الصيغة", edition: "الإصدار", chapters: "الفصول", allChapters: "كل الفصول", selected: "محددة", filter: "تصفية",
        answered: "مُجاب", unanswered: "بدون إجابة", include: "الأعمدة المضمّنة", fsNote: "إيضاح القوائم / مرجع ميزان المراجعة", comments: "ملاحظات",
        by: "أجاب / في", signoffs: "توقيعات الفصول", aiCol: "اقتراح الذكاء الاصطناعي (غير مقبول)", run: "تصدير", running: "جاري التحضير…",
        done: "التصدير جاهز", failed: "فشل التصدير",
      },
      col: {
        itemId: "رقم البند", chapter: "الفصل", ref: "المرجع", requirement: "المتطلب",
        type: "النوع", appliesWhen: "ينطبق عند", response: "الاستجابة", fsNote: "إيضاح القوائم / مرجع ميزان المراجعة", comments: "ملاحظات",
      },
    },
    w9: {
      title: "ورقة تقييم التحريفات",
      subtitle: "تقييم التحريفات غير المصحّحة مقابل 105(a).",
      tabUnresolved: "غير مُعالَجة",
      tabResolved: "مُعالَجة",
      showVoided: "عرض الملغاة",
      voidedBadge: "ملغى",
      ct: "حد الأهمية الضئيلة بشكل واضح",
      pm: "الأهمية النسبية للأداء",
      om: "الأهمية النسبية الإجمالية",
      empty: "لا توجد تحريفات بعد. أرسل من أي ورقة عمل.",
      recomputing: "جاري إعادة الحساب…",
      computedBackend: "أُعيد الحساب",
      computedWorker: "احتُسِبت بواسطة العامل",
      export: "تصدير الجدول",
      exporting: "جاري التصدير…",
      exportOk: "تم تنزيل الجدول.",
      col: { fsHead: "بند القوائم", description: "الوصف", type: "النوع",
              amount: "المبلغ", sfp: "الأثر على المركز المالي",
              pl: "الأثر على الربح أو الخسارة", source: "المصدر",
              commDate: "أُبلغ الإدارة", response: "رد الإدارة",
              ready: "ضمن التقييم", count: "العدد",
              net: "صافي", gross: "إجمالي", compared: "رقم المقارنة" },
      fpGross: "الأثر الإجمالي على المركز المالي",
      fpGrossHint: "مبلغ مطلق حسب بند القوائم المالية — لحالات التضخيم أو المبالغة في الأصول والالتزامات دون أثر صافٍ",
      correctWithEntry: "تصحيح بقيد",
      correctedByEntry: "مصحّح بالقيد {ref}",
      sourceLabels: {
        related_party: "الأطراف ذات العلاقة",
        completeness: "الاكتمال",
        estimate: "التقدير",
        observation: "الملاحظة",
        discrepancy: "التباين",
        w17_7: "\u2066W17.7\u2069 \u2066507(r)\u2069",
      },
      threshold: "حد مراجعة الاستراتيجية",
      thresholdHint: "الافتراضي: الأهمية النسبية للأداء. قابل للتعديل لكل ارتباط — تُسجَّل التغييرات.",
      strategyPromptQuiet: "رقم المقارنة الإجمالي {aggregate} أقل من حد مراجعة الاستراتيجية {threshold}.",
      signOff: "التوقيع",
      signedOffBy: "وقّع {name} · {date}",
      changeDate: "تغيير التاريخ",
      mtype: { Factual: "فعلي", Judgmental: "حُكمي", Projected: "متوقَّع", Disclosure: "إفصاح" },   // Disclosure: Batch 31 · item 10
      resp: { Corrected: "صُحِّح", Notcorrected: "لم يمّمعالجة" },
      responsePh: "اختَر…", reasonPh: "السبب مطلوب عند عدم التصحيح",
      readyYes: "نعم", readyNo: "بيانات ناقصة",
      readyReason: {
        missing_communicated_date: "أدخل تاريخ الإبلاغ إلى الإدارة",
        missing_response: "اختر رد الإدارة",
        missing_reason: "السبب مطلوب عند عدم التصحيح",
        missing_effect: "أدخل الأثر على المركز المالي أو على الربح أو الخسارة أو الأثر الإجمالي على المركز المالي",
        resolved: "",
      },
      pickSample: "اختر العيّنة", basis: "الأساس (يدوي)",
      projectedFromSample: "متوقَّع من العيّنة",
      evaluation: "تقييم التحريفات",
      uncorrected: "التحريفات غير المصحّحة — منفردة ومجمّعة",
      totalAggregate: "الإجمالي (المجمّع)",
      vsPm: "مقارنة بالأهمية النسبية للأداء",
      vsOm: "مقارنة بالأهمية النسبية الإجمالية",
      strategyPromptTitle: "التحريفات المتراكمة تقترب من الأهمية — أعد النظر في استراتيجية المراجعة",
      strategyPromptBody: "رقم المقارنة الإجمالي {aggregate} بلغ حد مراجعة الاستراتيجية {threshold}.",
      strategyPromptNotePh: "دوِّن تحديث الاستراتيجية أو اذكر سبب عدم الحاجة.",
      materialityReassessed: "هل لا تزال الأهمية النسبية عالية؟",
      qualitative: "العوامل النوعية",
      qual: { nature: "الطبيعة", circumstances: "الظروف",
                compliance_or_covenant: "الالتزام/التعهد",
                trend_reversal: "انعكاس الاتجاه",
                management_remuneration: "مكافآت الإدارة",
                other: "أخرى" },
      priorPeriod: "تحريفات غير مصححة من الفترة السابقة",
      tcwg: "أُبلغ المكلفون بالحوكمة",
      writtenRep: "تم الحصول على إفادة مكتوبة",
      wrPending: "قيد الانتظار", wrObtained: "تم الحصول عليها", wrNa: "لا ينطبق",
      openMRL: "افتح خطاب إفادة الإدارة",
      conclusion: "الاستنتاج",
      pickConclusion: "اختر استنتاجًا…",
      notMaterial: "التحريفات غير المصححة ليست جوهرية منفردةً أو مجمّعة",
      material: "التحريفات غير المصححة جوهرية",
      preparer: "المُعِدّ", reviewer: "المراجع",
      namePh: "الاسم الكامل", notePh: "ملاحظة",
    },
    w11: {
      title: "بوابة الاعتماد",
      subtitle: "المتطلبات التسعة التي يجب أن تكون خضراء قبل توقيع الشريك.",
      subtitleReview: "متطلبات الإجازة للفحص — يجب أن تكون كل بنود القائمة خضراء قبل توقيع الشريك.",
      refresh: "تحديث",
      item: "البند", status: "الحالة", detail: "التفاصيل",
      whoWhen: "من / متى", open: "فتح",
      readyPartner: "جميع البنود سليمة — يُسمح بتوقيع الشريك.",
      notReady: "{count} بند(بنود) تمنع توقيع الشريك.",
      refusalNote: "يرفض الخادم توقيع الشريك ما دام أحد البنود أعلاه محظورًا. عالِج المعوّقات ثم حدِّث.",
      pill: { ok: "سليم", blocked: "محظور", na: "غير منطبق", warn: "تنبيه — توقيع ناقص" },
      warningsTitle: "تنبيهات (لا تمنع البوابة)",
      warnings: { dc_incomplete: "قائمة الإفصاحات غير مكتملة — تمت الإجابة عن {answered} من {total} بندًا، و{open} ما زالت مفتوحة. أكملها قبل إصدار التقرير." },
      items: {
        checklist_1: "اكتمال جميع أوراق العمل والنماذج",
        checklist_2: "اعتماد نقاط المراجعة",
        checklist_3: "خُتمت \u2066W9\u2069",
        checklist_4: "الحصول على الإفادات المكتوبة",
        checklist_5: "مراجعة الأحداث اللاحقة",
        checklist_6: "خُتم قرار الاستمرارية (\u2066209(a)\u2069)",
        checklist_7: "اكتمال مراجعة جودة الارتباط",
        checklist_8: "توقيع \u2066W10\u2069 من المُعِدّ والمراجع",
        checklist_9: "التواصل مع المكلفين بالحوكمة",
        review_1: "اعتماد جميع أوراق الفحص (\u2066W17.1–W17.8\u2069)",
        review_2: "\u2066W17.4\u2069 — الرد على الاستفسارات التسعة المطلوبة",
        review_3: "اعتماد نقاط المراجعة",
        review_4: "خُتمت \u2066W9\u2069",
        review_5: "الحصول على الإفادات المكتوبة",
        review_6: "مراجعة الأحداث اللاحقة",
        review_7: "خُتم قرار الاستمرارية (\u2066209(a)\u2069)",
        review_8: "اكتمال مراجعة جودة الارتباط",
        review_9: "توقيع \u2066W10\u2069 من المُعِدّ والمراجع",
        review_10: "التواصل مع المكلفين بالحوكمة",
        review_11: "اكتمال نماذج الفحص الأخرى أو عدم انطباقها",
      },
      details: {
        forms_all_ok: "جميع النماذج المشمولة مكتملة 100%.",
        forms_incomplete: "{count} نموذج(نماذج) لم يكتمل:",
        other_forms_all_ok: "جميع نماذج الفحص الأخرى مكتملة أو مُعلَّمة كغير منطبقة. النماذج المرمّدة (خاصة بالتدقيق) مُستبعَدة.",
        other_forms_incomplete: "{count} نموذج فحص لم يكتمل أو لم يُعلَّم بعد:",
        more_suffix: "(+{n} أخرى)",
        rp_all_cleared: "تم اعتماد جميع نقاط المراجعة.",
        rp_open: "{count} نقطة(نقاط) مراجعة لم تُعتمَد بعد.",
        w9_not_material: "استنتاج \u2066W9\u2069: غير جوهرية.",
        w9_material: "استنتاج \u2066W9\u2069: جوهرية.",
        w9_not_concluded: "لم يُسجَّل استنتاج \u2066W9\u2069 بعد.",
        w17_all_signed: "تم توقيع \u2066W17.1–W17.8\u2069 بالكامل.",
        w17_pending: "أوراق فحص لم تُوقَّع بعد: {missing}.",
        w17_4_all_answered: "تمت الإجابة على الاستفسارات التسعة المطلوبة.",
        w17_4_pending: "{count} من الاستفسارات التسعة المطلوبة لم يُجَب عليها بعد.",
        wr_not_built: "لم يُبنَ بعد — رسالة تمثيل الإدارة غير موجودة في مكتبة النماذج الحالية.",
        wr_not_started: "لم يبدأ — لم تُفتَح رسالة تمثيل الإدارة بعد.",
        wr_incomplete: "رسالة تمثيل الإدارة لم تكتمل بعد.",
        wr_obtained: "تم الحصول على الإفادات المكتوبة.",
        wr_na: "مُعلَّم كغير منطبق.",
        subs_not_built: "لم يُبنَ بعد — الأحداث اللاحقة غير موجودة في مكتبة النماذج الحالية.",
        subs_not_started: "لم يبدأ — لم تُفتَح الأحداث اللاحقة بعد.",
        subs_incomplete: "نموذج الأحداث اللاحقة لم يكتمل بعد.",
        subs_obtained: "تمت مراجعة الأحداث اللاحقة.",
        subs_na: "مُعلَّم كغير منطبق.",
        gc_not_built: "لم يُبنَ بعد — \u2066209(a)\u2069 غير موجود في مكتبة النماذج الحالية.",
        gc_not_started: "لم يبدأ — لم يُفتَح \u2066209(a)\u2069 بعد.",
        gc_pending: "لم يُختَر استنتاج الاستمرارية (\u2066209(a)\u2069) بعد.",
        gc_concluded: "اختُتِمت الاستمرارية — {option_label_key}.",
        gc_na: "مُعلَّم كغير منطبق.",
        eqr_not_required: "مراجعة جودة الارتباط غير مطلوبة لهذه المهمة.",
        eqr_ok: "نموذج \u2066522(a)\u2069 — الاستنتاج العام: اكتملت على نحو مُرضٍ.",
        eqr_pending: "نموذج \u2066522(a)\u2069 لم يبلغ 'اكتملت على نحو مُرضٍ' بعد (\u2066ISQM 2.24(b), 27; ISA 220 (Revised)\u2069).",
        w10_not_started: "لم تبدأ مذكرة ملخص المراجعة \u2066W10\u2069.",
        w10_missing: "\u2066W10\u2069 ينقصها التوقيع: {roles}.",
        w10_signed: "وقّع \u2066W10\u2069 المُعِدّ ({preparer_name}) والمراجع ({reviewer_name}).",
        tcwg_not_recorded: "لم يُسجَّل تاريخ التواصل مع المكلفين بالحوكمة على \u2066W9\u2069 بعد.",
        tcwg_log_ok: "آخر اتصال {date} · {category} · {to}",
        tcwg_add_to_log: "أضِف صف نتائج جوهرية إلى سجل \u2066311(a)\u2069.",
        tcwg_ok: "تم التواصل مع المكلفين بالحوكمة في {date}.",
        tcwg_na_ok: "التواصل مع المكلفين بالحوكمة معتبَر غير مُطبَّق — السبب: {reason}",
      },
      consistency: {
        recheck: "إعادة الفحص", na: "لا ينطبق", proceed: "المتابعة إلى توقيع الشريك", overrideTitle: "فحوصات اتساق فاشلة",
        overrideText: "فشلت هذه الفحوصات. توقيع الشريك غير محظور، لكن سيتم تسجيل التجاوز في سجل التدقيق:",
        overrideConfirm: "تأكيد التجاوز", overrideOk: "تم تسجيل التجاوز في سجل التدقيق — تابع إلى توقيع الشريك",
        orphans: "غير مرتبط", entries: "قيود", count: "العدد", lead: "الورقة الرئيسية", noLeads: "لا توجد أوراق رئيسية بعد",
        title: "فحوصات الاتساق",
        warnOnly: "تحذيرات فقط — لا تمنع توقيع الشريك.",
        c1: "استخدام الأهمية النسبية نفسها في التخطيط والعينات و\u2066W9\u2069",
        c2: "لكل مخاطرة إجراء مرتبط (وكل إجراء منفَّذ مرتبط بمخاطرة)",
        c3: "تحريفات \u2066W9\u2069 تطابق قيود \u2066302(a)\u2069",
        c4: "استنتاج الاستمرارية \u2066209(a)\u2069 يطابق تحفظ / تعديل تقرير المدقق",
        c5: "تسلسل التوقيع: المُعِدّ ≤ المراجع ≤ الشريك",
        c6: "إجمالي ورقة البنود يطابق ميزان المراجعة لكل بند",
        pass: "ناجح", fail: "فشل",
        detailFmt: {
          c1_ok: "تتطابق الأهمية النسبية الخاصة بالتخطيط مع العينات و\u2066W9\u2069.",
          c1_bad: "{n} عدم تطابق: {list}",
          c1_item: "{src} {field} = {used} بدلاً من {expected}",
          c1_specific: "ليست عينة — لا تُقارن",   // Batch 15 · N2 (F-116)
          c2_ok: "لكل مخاطرة إجراء مرتبط، ولكل إجراء منفَّذ مخاطرة.",
          c2_orphans: "{n_risks} مخاطرة بدون إجراء مرتبط{maybe_procs}",
          c2_orphans_procs: " و{n_procs} إجراء منفَّذ بدون مخاطرة مرتبطة",
          c2_risk_item: "المخاطرة «{title}» لا يوجد إجراء مرتبط بها",
          c3_ok: "\u2066W9\u2069 و\u2066302(a)\u2069 متفقان في العدد ({n}).",
          c3_bad: "عدد \u2066W9\u2069 = {w9} بينما عدد \u2066302(a)\u2069 = {f302}",
          c4_ok: "استنتاج الاستمرارية يطابق تقرير المدقق.",
          c4_bad: "\u2066209(a)\u2069 يقول: شك = {gc}، بينما التقرير يحوي تعديل = {rpt}",
          c5_ok: "تسلسل وتواريخ التوقيع صحيحة.",
          c5_bad: "مخالفات الترتيب: {list}",
          c6_ok: "جميع البنود مطابِقة لميزان المراجعة.",
          c6_bad: "{n} بند(ود) غير مطابق: {list}",
          c6_item: "{code}: ميزان {tb} بينما ورقة البنود {lead} (الفرق {diff})",
        },
      },
    },
    wt: {
      title: "الاستعراضات + التصميم والتنفيذ",
      purpose: "صف واحد لكل عملية. \"الاعتماد على الرقابة = نعم\" ينشئ صف اختبار رقابة.",
      required: "الوصف أو معرف الرقابة مطلوب.",
      saved: "تم حفظ الاستعراض",
      noSeed203a: "لا توجد إجابات في \u2068203(a)\u2069 لتعبئتها مسبقًا",
      empty: "لا توجد استعراضات بعد — أضف واحدًا بالأعلى.",
      add: "إضافة استعراض",
      saveBtn: "حفظ الاستعراض",
      relyOnControl: "الاعتماد على الرقابة (← اختبارات الرقابة)",
      effective: "فعّالة",
      ineffective: "غير فعّالة",
      na: "غير منطبقة",
      processPh: "مثال: فصل فترات الإيراد",
      procedurePh: "إجراء الاستعراض",
      controlIdPh: "معرف الرقابة",
      assertionPh: "التوكيد",
      riskRefPh: "اختر مخاطرة من السجل…",
      descriptionPh: "وصف الرقابة",
      objectivePh: "الهدف",
      ownerPh: "المالك",
      walkthroughDone: "تم الاستعراض",
      designEffective: "التصميم فعّال",
      implemented: "منفَّذ",
      deficiencyFlag: "قصور (← السجل)",
      attachEvidence: "إرفاق دليل",
      evidenceAttached: "تم إرفاق الدليل.",
      sourceForm203a: "نموذج المصدر: 203(a) ←",
      col: {
        ref: "المرجع", area: "المجال", procedure: "الإجراء",
        conclusion: "التصميم والتنفيذ", rely: "الاعتماد",
        controlId: "معرف الرقابة", description: "الوصف",
        assertion: "التوكيد", ma: "يدوي/آلي", pd: "وقائي/كاشف",
        freq: "التكرار", owner: "المالك", di: "التصميم", impl: "التنفيذ",
        deficiency: "قصور؟", evidence: "الدليل",
      },
      ma: { manual: "يدوي", automated: "آلي", it_dependent: "معتمد على تقنية المعلومات" },
      pd: { preventive: "وقائي", detective: "كشفي" },
      freq: {
        daily: "يومي", weekly: "أسبوعي", monthly: "شهري",
        quarterly: "ربع سنوي", annually: "سنوي", on_occurrence: "عند الحدوث",
      },
      controlCycle: "دورة الرقابة",
      controlCycleHint: "مخطط تدفق أو وصف سردي أو مستند العملية.",
      walkthroughDateLabel: "تاريخ جولة الفحص",
      sourceForm203a: "نموذج المصدر: 203(a) ←",
      attachFile: "إرفاق ملف",
      noFiles: "لا توجد ملفات بعد.",
      cycleAttached: "تم إرفاق ملف دورة الرقابة.",
      process: {
        revenue: "الإيرادات",
        purchases: "المشتريات",
        payroll: "الرواتب",
        cash: "النقد",
        inventory: "المخزون",
        financial_close: "الإقفال المالي",
      },
    },
    itgc: {
      title: "الضوابط العامة لتقنية المعلومات",
      purpose: "أربعة مجالات: أمن الوصول · إدارة التغيير · عمليات تقنية المعلومات · تطوير البرامج.",
      pass: "ناجح", fail: "غير ناجح", na: "غير منطبق", not_assessed: "لم يُقيَّم",
      notePh: "ملاحظة / مرجع دليل",
      domain: {
        access_security: "أمن الوصول",
        change_management: "إدارة التغيير",
        it_operations: "عمليات تقنية المعلومات",
        program_development: "تطوير البرامج",
      },
      col: {
        domain: "المجال", control: "الضابط", status: "الحالة", note: "ملاحظة",
        controlId: "معرف الرقابة", controlIdPh: "معرف الرقابة", description: "الوصف",
        ma: "يدوي / آلي", pd: "وقائي / كشفي",
        freq: "التكرار", owner: "المالك",
        di: "التصميم فعّال", impl: "منفَّذ", rely: "الاعتماد على الرقابة",
      },
    },
    toc: {
      title: "اختبارات الرقابة",
      purpose: "اختبارات الفعالية التشغيلية للضوابط التي ننوي الاعتماد عليها.",
      refRequired: "مرجع الضابط مطلوب.",
      saved: "تم حفظ صف الاختبار",
      empty: "لا توجد اختبارات رقابة بعد.",
      add: "إضافة اختبار رقابة",
      saveBtn: "حفظ الاختبار",
      controlRefPh: "مثال: WT-01",
      attributePh: "السمة المُختبَرة",
      relied: "معتمَد",
      notRelied: "غير معتمَد",
      naTitle: "غير منطبق — لا يوجد اعتماد على الرقابة",
      naExplain: "لا يوجد استعراض معدّ للاعتماد على الرقابة، فلا تُنفَّذ اختبارات الفعالية التشغيلية.",
      naReason: "السبب (موثّق)",
      naReasonPh: "مثال: تم تبنّي منهج جوهري بالكامل.",
      col: { ref: "المرجع", control: "الضابط", attribute: "السمة",
              sample: "العينة", exceptions: "الاستثناءات", conclusion: "الاستنتاج" },
    },
    cd: {
      title: "سجل قصور الضوابط",
      purpose: "ISA 265 — قصور وقصور مهم فقط. القصور المهم يغذّي 322(a) خطاب الإدارة.",
      descRequired: "الوصف مطلوب.",
      tcwgRequired: "تاريخ إبلاغ TCWG مطلوب لكل قصور جوهري.",
      tcwgHint: "تاريخ إبلاغ TCWG مطلوب قبل إغلاق الصف.",
      saved: "تم تسجيل القصور",
      empty: "لم يُسجَّل أي قصور بعد.",
      add: "تسجيل قصور جديد",
      saveBtn: "تسجيل القصور",
      descPh: "صف القصور…",
      controlIdPh: "معرف الرقابة (اختياري)",
      areaPh: "مجال الرقابة",
      wpPh: "مثال: \u20664101-05.02\u2069",
      wpLabel: "رابط ورقة العمل",
      commMgmtPh: "تاريخ خطاب الإدارة",
      commTcwgPh: "تاريخ TCWG",
      commMgmtLabel: "تاريخ إبلاغ الإدارة",
      commTcwgLabel: "تاريخ إبلاغ TCWG (مطلوب للقصور المهم)",
      deficiency: "قصور",
      significant: "قصور مهم",
      feeds322a: "يوجد {count} إدخالًا يُغذّي 322(a) خطاب الإدارة.",
      source: { manual: "يدوي", walkthroughs: "جولة",
                 tests_of_controls: "اختبارات الرقابة",
                 itgc: "رقابات تقنية", observation: "ملاحظة رئيسية" },
      status: { open: "مفتوح", communicated: "أُبلغ", cleared: "مُغلق" },
      col: { ref: "المرجع", source: "المصدر", controlId: "معرف الرقابة",
              desc: "الوصف", severity: "الشدة",
              commMgmt: "إبلاغ الإدارة", commTcwg: "إبلاغ TCWG",
              status: "الحالة" },
    },
    proc: {
      title: "الإجراءات المُنفَّذة",
      col: { ref: "المرجع", proc: "الإجراء", assertions: "الإقرارات",
              source: "المصدر", performed: "مُنفَّذ", reason: "السبب / التعليق",
              doneBy: "نفّذه / التاريخ", wp: "مرجع ورقة العمل" },
      yes: "نعم", no: "لا", na: "غير منطبق",
      naReason: "الحالة \"غير منطبق\" تستلزم سببًا",
      noReason: "الحالة \"لا\" تستلزم تعليقًا",
      source: { library: "المكتبة", plan: "خطة الاستجابة",
                 additional: "إضافي", alternate: "بديل" },
      replaced: "استُبدل بإجراء بديل",
      addAdditional: "إضافة إجراء إضافي", addAlternate: "إضافة إجراء بديل",
      completePct: "المكتمل",
      conclusion: "الاستنتاج", preparer: "المُعِد", reviewer: "المراجع",
      markComplete: "وضع علامة \"مكتمل\"",
      newProcedure: "نص الإجراء",
      pickAlternateOriginal: "الإجراء الأصلي المراد استبداله",
      guard: {
        notDecided: "حدّد قرار النطاق في التخطيط ← تحديد النطاق لتحميل إجراءات المكتبة.",
        notDecidedLink: "فتح صفحة تحديد النطاق",
      },
    },
    assert: {
      E: "الوجود / الحدوث", C: "الاكتمال", A: "الدقة",
      V: "التقييم والتخصيص", CO: "فصل الفترات", R: "الحقوق والالتزامات",
      CL: "التصنيف", P: "العرض والإفصاح", All: "الكل",
    },
    hfWs: {
      aging: {
        title: "ورقة عمل الأعمار",
        arTitle: "أعمار المدينين — 1203-06",
        apTitle: "أعمار الدائنين — 3203-06",
        arTitleShort: "أعمار المدينين",
        apTitleShort: "أعمار الدائنين",
        tbTrade: "رصيد الميزان (تجاري) = مجموع الحسابات المُفعَّلة.",
        agingTotal: "إجمالي تقرير الأعمار",
        tbBalance: "رصيد ميزان المراجعة (الذمم التجارية فقط)",
        folderTotal: "إجمالي المجلد (كل حسابات المجلد)",
        difference: "الفرق (الدفتر − تقرير الأعمار)",
        linkedUpload: "ملف الأعمار المستخدم",
        differenceZero: "الأعمار متطابقة مع ميزان المراجعة. ✓",
        differenceNonZero: "الأعمار لا تتطابق مع ميزان المراجعة — يرجى التوضيح والاستنتاج.",
        explanation: "توضيح الفرق",
        explanationReq: "مطلوب عندما يكون الفرق ≠ 0.",
        conclusion: "الاستنتاج",
        preparer: "المُعِد",
        completedAt: "تاريخ الإنجاز",
        markComplete: "وضع علامة \"مكتمل\"",
        markCompleteGate: "املأ التوضيح (إذا كان الفرق ≠ 0) والاستنتاج أولاً.",
        completedBadge: "مكتمل",
        loading: "جارِ تحميل ورقة العمل…",
        noAgingUpload: "لم يُرفع تقرير أعمار لهذا المجلد بعد.",
        coaFieldNote: "فلتر الميزان يستخدم coa_mappings.mapping ⊇ 'trade' مع 'receivab'/'payab' وحيث fs_mapping = {code}.",
        accountsTitle: "الحسابات في هذا المجلد",
        colTrade: "تجاري",
        colCode: "الرمز",
        colName: "اسم الحساب",
        colBalance: "رصيد الميزان",
        colTag: "الحالة",
        blankName: "اسم فارغ",
        needsClassification: "يحتاج تصنيف",
        suggestedTrade: "الاقتراح: تجاري",
        suggestedNonTrade: "الاقتراح: غير تجاري",
        overridden: "تجاوز المدقق",
        markCompleteGateUnclassified: "صنّف كل الحسابات (فعّل أو ألغِ خانة \"تجاري\") أولاً.",
      },
      badge: {
        cutoff: "فصل الفترات",
        aging: "أعمار",
        completeness: "الاكتمال",
        inventory_count: "جرد المخزون",
        estimate: "التقدير",
        related_party: "أطراف ذات علاقة",
      },
      row: {
        completeness: "ورقة اختبار الاكتمال",
        inventory_count: "ورقة عمل جرد المخزون",
        estimate: "ورقة عمل التقديرات",
        related_party: "معاملات الأطراف ذات العلاقة",
        aging: "الأعمار",
        cutoff: "فصل الفترات",
      },
      addWorksheet: "إضافة ورقة عمل",
      added: "تمت إضافة ورقة العمل",
      cutoff: {
        title: "ورقة عمل القطع الزمني",
        titleShort: "اختبار فصل الفترات",
        rowText: "اختبار فصل الفترات",
        std: "ISA 330؛ ISA 500",
        stdCodes: ["ISA 330", "ISA 500"],
        stdSep: "؛ ",
        windowDays: "أيام قبل/بعد نهاية الفترة",
        colDate: "التاريخ",
        colVoucher: "السند",
        colAccount: "الحساب",
        colAmount: "المبلغ",
        recordedCorrectly: "هل سُجِّل في الفترة الصحيحة؟",
        remarks: "ملاحظات",
        support: "الدليل",
        supportDocLabel: "المستند المؤيد",
        replace: "استبدال",
        view: "عرض",
        yes: "نعم",
        no: "لا",
        preYearEnd: "القيود قبل نهاية السنة (تم اختيارها تلقائيًا)",
        postYearEnd: "القيود بعد نهاية السنة",
        uploadPye: "رفع قيود ما بعد نهاية السنة (.xlsx / .csv)",
        uploadPyeCols: "الأعمدة: التاريخ، السند، الحساب، المبلغ، الوصف",
        uploadDocs: "رفع المستندات",
        uploadDocsHint: "إشعارات التسليم، الفواتير، وإشعارات القيد بعد نهاية الفترة. يُسمح بعدة ملفات.",
        conclusion: "الاستنتاج",
        preparer: "المُعِد",
        conclusionDate: "التاريخ",
        completedAt: "تاريخ الإنجاز",
        markComplete: "وضع علامة \"مكتمل\"",
        markCompleteGate: "املأ الاستنتاج والمُعِد والتاريخ أولًا.",
        sendBtn: "إرسال إلى ملخص التحريفات",
        sentIndicator: "تم الإرسال إلى ملخص التحريفات", resendBtn: "إرسال مجددًا (تحديث المبلغ)",
        noAccounts: "هذا المجلد ليس له حسابات في تعيين القوائم المالية الحالي — لم تُنشأ ورقة عمل.",
        uploadedBy: "بواسطة",
        uploadedAt: "بتاريخ",
      },
    },
  },
};

export default I18N_BASE_FIELDWORK;
